import { Box, Skeleton } from '@mui/material';
import { useQuery } from 'react-query';
import { If } from 'src/components/If';
import { PanelLogin } from 'src/components/PanelLogin';
import { useAuthContext } from 'src/context/AuthContextProvider';
import { getOperationDailyQuotaProvider } from 'src/services/operation/operationFidc';

import { DailyQuotaCharts } from './DailyQuotaCharts';
import { DailyQuotaProviders } from './components/DailyQuotaProviders';
import { DailyQuotaProvidersNoData } from './components/DailyQuotaProvidersNoData';

type OperationFIDCAdministratorProps = {
  hash: string;
};

export function OperationFIDCAdministrator({
  hash,
}: OperationFIDCAdministratorProps) {
  const { auth } = useAuthContext();
  const permission =
    auth?.user?.subscription?.plan?.permissions?.operacoes_informes_recorrentes;

  const { data, isLoading } = useQuery({
    queryKey: ['operation-fidc-administrator', hash],
    queryFn: () => getOperationDailyQuotaProvider(hash),
    enabled: !!hash && permission,
  });
  return (
    <Box p={2}>
      <Box>
        <If condition={!permission}>
          <PanelLogin />
        </If>
        <If condition={permission}>
          <If condition={isLoading}>
            <Box>
              <Skeleton variant="rectangular" width="100%" height={30} />
            </Box>
          </If>
          <If condition={data?.length && data?.length > 0}>
            <DailyQuotaProviders data={data} />
          </If>
          <If condition={!isLoading && (!data?.length || data?.length === 0)}>
            <DailyQuotaProvidersNoData />
          </If>
          <DailyQuotaCharts hashId={hash} />
        </If>
      </Box>
    </Box>
  );
}
